export default __webpack_public_path__ + "static/media/suhas.244c0670.jpg";